// src/api/companyApi.js
import jbAPI from "./jobboard";

export const fetchCompanyById = async (companyId, token) => {
  try {
    const response = await jbAPI.get(`/listCompanyByID/${companyId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch company detail:", error);
    throw error;
  }
};

/**
 * Update an existing company profile.
 *
 * @param {string|number} companyId  – the company’s ID
 * @param {Object|FormData} payload  – data you want to PUT
 * @param {string} token             – Bearer token
 * @returns {Promise<Object>}        – updated company object (or full response.data)
 */
export const updateCompanyById = async (companyId, payload, token) => {
  try {
    const res = await jbAPI.put(
      `/updateCompany/${companyId}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type":
            payload instanceof FormData ? undefined : "application/json",
        },
      },
    );

    return res.data;         
  } catch (err) {
     console.error("Failed to update company detail:", err);
    throw err;                
  }
};
